<template>
  <div class="header" :class="{ 'header-min': topLevel }">
    <HistoryState v-if="getUserInfo.id" ref="hisRef"/>
    <div class="logo" @click="$gopage('index')">
      <a>
        <img class="logoImg" v-if="!orgaImg" src="~images/logo.png" />
        <img class="logoImg" v-else :src="orgaImg" />
      </a>
      <span v-if="topLevel">{{ headTitle }}</span>
      <div class="sogo" v-if="topLevel">学好语文，从爱上朗读开始</div>
    </div>
    <div class="pos">
      <!-- <template v-for="(item, index) in posNavs">
        <a
          @click="navClick(item)"
          v-if="item.pathName"
          :class="{ actived: item.actived }"
          ><i class="icon icon-home" v-if="item.pathName == 'index'"></i
          >{{ item.name }}</a
        ><i v-if="index < posNavs.length - 1">&nbsp;&gt;&nbsp;</i>
        <span v-if="!item.pathName">{{ item.name }}</span>
      </template> -->
    </div>
    <div class="right-menu">
      <template v-if="!getUserInfo.id">
        <a href="/user/pwdLogin" style="margin-right: 24px;" v-if="isTestEvn">密码登录</a>
        <template v-for="(item, index) in navList">
          <a :class="{ actived: item.id == actId }" @click="topNavClick(item)">{{
            item.name
          }}</a>
          <span></span>
        </template>
      </template>
      <template v-else>
        <a class="flex-center" @click="$refs.verifyRef.status = true">
          <img src="https://llss-file.langsounds.com/app/30ede98fc6a1924b97628e95395d2774.png" />入班审核
          <i class="flex-center aNum" v-if="warmNum">{{warmNum}}</i>
        </a>
        <span></span>
        <a class="flex-center" @click="$refs.favRef.init()">
          <img src="https://llss-file.langsounds.com/app/9163bf16f475b82e7561d6b288d7b438.png" />收藏
        </a>
        <span></span>
      </template>

      <div class="user">
        <div class="has-login flex-center" v-if="getUserInfo">
          <template v-if="getUserInfo.id">
            <div class="userImg">
              <img :src="getUserInfo.photo" />
              <i class="iconfont VIP_biaoshi uVip" v-if="getUserInfo.memberFlag"></i>
            </div>
            <a class="uName">{{ getUserInfo.nickName }}</a>
            <i class="iconfont lujing1-copy" style="color: #57AE59;"></i>
          </template>
          <div v-else class="personLogin" @click.stop="$user.checkIsLogin()">
            <!-- 个人版登录 -->
            <img class="iconImgs"
              src="https://reading.oss.iyougu.com/rcweb/image/2023-04-07/bed0ebdbb5d14b5da3348f10bbe6eef3.png" />
          </div>
          <div class="sub-menu" v-if="getUserInfo.id">
            <ul class="list">
              <li @click="openQuery(0)">个人信息</li>
              <li @click.stop="openQuery(1)">退出登录</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <BuyBook ref="buyBook" />
    <FavList ref="favRef" />
    <Verify ref="verifyRef" @onCount="warmNum = $event"/>
    <Dialog :title="isOut ? '退出登录' : '个人信息'" :modal="true" width="900px" :visible.sync="status">
      <div class="vfWrap flex-v flex-center">
        <p class="diTxt" v-if="isOut">是否登出当前账号？</p>
        <template v-else>
          <h4 class="bName">
            账号昵称
          </h4>
          <Input v-model="nickName" :placeholder="`请输入账号昵称`" style="width: 320px" :maxlength="10" clearable></Input>
        </template>
        <div class="dialog-footer">
          <div class="btn cancel flex-center" @click="status = false">取 消</div>
          <div class="btn sure flex-center" @click="logOut" v-if="isOut">登 出</div>
          <div class="btn sure flex-center" @click="updateTeacher" v-else>修 改</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import {
  Dialog,
  Input
} from "element-ui";
import BuyBook from "business/BuyBook";
import FavList from "../../pages/book/favList.vue";
import Vue from "vue";
import util from "libs/util";
import HistoryState from "./HistoryState.vue";
import Verify from "../../pages/course/manage/verify.vue";

export default {
  components: {
    BuyBook,
    FavList,
    HistoryState,
    Verify,
    Dialog,
    Input,
  },
  computed: {
    ...mapGetters(["getNavActiveIndex", "getUserInfo"]),
  },
  watch: {
    getUserInfo: {
      handler() { },
      deep: true,
    },
  },
  props: {
    actId: {
      type: String,
      default: "",
    },
    headTitle: {
      type: String,
      default: "",
    },
    topLevel: {
      type: Boolean,
      default: false,
    },
    posNavs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      warmNum: 0,
      nickName: '',
      status: false,
      isOut: true,
      navList: [
        {
          id: 1,
          name: "首页",
          pathName: "index",
        },
        {
          id: 4,
          name: "诵读资料库",
          pathName: "book_ware",
        },
        {
          id: 2,
          name: "名家介绍",
          pathName: "introduction",
        },
        {
          id: 3,
          name: "关于我们",
          pathName: "about",
        },
      ],
      orgaImg: "",
      isTestEvn: process.env.NODE_ENV !== "production"
    };
  },
  created() { },
  mounted() {
    if (util.getStorage("LLSS_TOKEN") && util.getStorage("orgaId")) {
      this.checkedOrga();
    }
  },
  methods: {
    // 课程详情页打开底部菜单
    coursePageMenuStatus() {
      this.$refs.hisRef && this.$refs.hisRef.chnageStatus();
    },
    openQuery(toOut) {
      this.nickName = this.getUserInfo.nickName;
      this.isOut = toOut;
      this.status = true;
    },
    gotoOrga() {
      const isTest = location.host.indexOf("test") > -1;
      const isLocalhost = location.host.indexOf("localhost") > -1;
      console.log('11111111111', isTest, isLocalhost);
      if (isTest || isLocalhost) {
        window.location.href = "https://trcweb.ygr.iyougu.com/#/";
      } else {
        window.location.href = "https://rcweb.iyougu.com/#/"
      }
    },
    // 查找机构信息
    checkedOrga() {
      let url = `/passport/orgainfo.json`;
      this.$post(url, {})
        .then((res) => {
          this.orgaImg = res.data.llssMpLogo;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async logOut() {
      this.$loading.show();
      const res = await this.$post("/passport/logout.json");
      if (res.status == 200) {
        util.removeStorage("LLSS_TOKEN");
        this.$store.dispatch("setUserInfo", {});
        this.$store.dispatch("setIsLogin", 0);
        console.log("----------退出登录");
        this.$gopage("index", {}, true, true);
      } else {
        this.$toast(res.message);
      }
      this.status = false;
      this.$loading.hide();
    },
    toAuthMember() {
      this.$refs.buyBook && this.$refs.buyBook.open();
    },
    navClick(item) {
      if (!item.callback) {
        this.$gopage(item.pathName);
      } else {
        item.callback();
      }
    },
    topNavClick(item) {
      let id = util.getStorage('LLSH_LAST_WARE');
      this.$gopage(item.pathName,item.id == 4 ? {id} : null);
    },
    async updateTeacher() {
      if (this.nickName == this.getUserInfo.nickName) return this.status = false;
      if (!this.nickName) return this.$toast('请输入账号昵称');
      try {
        await this.$post('/home/updateNickname.json', {
          nickName: this.nickName,
        })
        this.$store.dispatch('setUserInfo', {
          ...this.getUserInfo,
          nickName: this.nickName,
        });
        this.status = false;
        this.$toast('姓名修改成功');
      } catch (error) {
        this.$toast('修改失败，请核验信息后重试');
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~styles/mixin";
@import "~styles/var";

.bName {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
  margin-bottom: 24px;
}
.diTxt {
  font-size: 24px;
  color: #333333;
}

.header {
  padding: 16px 20px 16px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ECECEC;

  .logo {
    display: flex;
    align-items: center;

    .logoImg {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }

    span {
      font-size: 24px;
      color: #333;
      margin-left: 20px;
      white-space: nowrap;
    }

    .sogo {
      margin-left: 10px;
      color: #999;
      position: relative;
      top: 2px;
    }
  }

  .pos {
    float: left;
    color: #999;
    font-size: 14px;
    flex: 1;
    line-height: 20px;
    padding-left: 24px;

    a {
      display: inline-block;
      align-items: center;
    }

    >span {
      color: @theme;
    }

    i.icon-home {
      margin-right: 8px;
      vertical-align: -3px;
    }
  }

  .right-menu {
    float: right;
    color: #666;
    line-height: 20px;
    display: flex;
    align-items: center;
    padding-right: 40px;

    span,
    a {
      float: left;
      position: relative;

      img {
        width: 17px;
        height: 17px;
        margin-right: 4px;
      }
      .aNum {
        width: 18px;
        height: 12px;
        background: #FF5C5C;
        border-radius: 6px;
        color: #fff;
        font-size: 10px;
        font-style: normal;
        transform: scale(.8);
        position: absolute;
        top: -4px;
        left: 8px;
      }
    }

    a.actived {
      color: @theme;
    }

    span {
      width: 2px;
      height: 8px;
      background: #d8d8d8;
      margin: 0 15px;
      display: inline-block;
    }

    .fav {
      .bg-url("~images/icon-fav.png");
      width: 16px;
      height: 16px;
    }

    .user {
      .has-login {
        // width: 32px;
        // height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        z-index: 3;
        padding: 10px 0;

        .personLogin {
          display: flex;
          align-items: center;
          justify-content: center;
          // padding: 6px 8px;
          border-radius: 50%;
          // border: 1px solid #eeeeee;
          // font-size: 14px;
          // font-family: "PingFangSC-Medium, PingFang SC";
          // color: #81cb44;
          width: 32px;
          height: 32px;
          background: #F2F2F2;
        }

        .iconImgs {
          width: 16px;
          height: 16px;
          // margin-left: 4px;
          // border-radius: 0;
        }

        .rcwebEnters {
          display: flex;
          align-items: center;
          padding: 6px 8px;
          border-radius: 5px;
          border: 1px solid #eeeeee;
          font-size: 14px;
          font-family: "PingFangSC-Medium, PingFang SC";
          color: #fb7c33;
          margin-left: 8px;
        }

        .sub-menu {
          position: absolute;
          width: 100px;
          box-sizing: border-box;
          padding: 10px 0;
          right: -20px;
          top: 30px;
          display: none;

          .list {
            background: #fffcf7;
            padding: 10px;
            box-shadow: 0px 16px 19px -5px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            text-align: center;
            box-sizing: border-box;
            line-height: 40px;

            li {
              cursor: pointer;
              border-bottom: 1px solid #f0e8da;
              // height: 40px;

              &:hover {
                color: @theme;
              }

              &:last-child {
                border: 0;
              }
            }
          }
        }

        &:hover {
          .sub-menu {
            display: block;
          }
        }

        .userImg {
          position: relative;
          overflow: hidden;

          .uVip {
            position: absolute;
            bottom: -6px;
            left: -9px;
            font-size: 13px;
            color: #FF5C5C;
          }
        }

        .uName {
          margin-left: 8px;
          margin-right: 6px;
        }

        img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          // position: relative;
          // &::after {
          //   content: '';
          //   display: inline-block;

          //   position: absolute;
          // }
        }
      }
    }
  }

  &.header-min {
    padding: 0;

    .logo {
      // width: 120px;
      padding-left: 40px;
      border-bottom: 0;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
  }
}
</style>